// dbext:profile=staging_mcdo2019_be
import $    from "jquery";
import slug from "speakingurl"; // for slugify()

export default {

    init()
    {
        // editing node?
        if ( $('body.path-node').length === 1 ){
            this.content_edit_hide_help_text_about_text_formats();
        }

        // generate slug buttons
        if ( $('.js-link-generate-slug').length > 0 ){
            $('.js-link-generate-slug').on( 'click', this.on__slug_arrow__click() );
        }

    },

    content_edit_hide_help_text_about_text_formats()
    {
        /*
            The help text looks like this:
                About text formats
                <span class="translation-entity-all-languages">(all languages)</span>
            That sucks! ⇒ hide it
         */

        $('body.path-node .filter-help:contains("About text formats")').hide();
    },

    on__slug_arrow__click()
    {
        return ( e ) => {
            e.preventDefault();

            let de_clicked = $(e.currentTarget);
            let slug_source = de_clicked.data( 'slug_source' );
            let slug_target = de_clicked.data( 'slug_target' );

            let de_slug_source = $('input[name="'+slug_source+'"]');
            let de_slug_target = $('input[name="'+slug_target+'"]');

            if ( de_slug_source.length === 0 ){ return; }
            if ( de_slug_target.length === 0 ){ return; }

            let s = de_slug_source.val();
            if ( ! s ){
                return;
            }

            s = this.slugify( s );
            de_slug_target.val( s );

            this.flash_background( de_slug_target );
        };
    },

    slugify( s )
    {
        s = s.replace( /®/g, '' );
        s = s.replace( /©/g, '' );
        s = s.trim();
        s = slug( s );
        s = s.toLowerCase();
        return s;
    },

    bread_crumb_add_mcdonalds_link()
    {
        let de_breadcrumb = $('#block-seven-breadcrumbs .breadcrumb ol');
        if ( de_breadcrumb.length === 0 ){
            return;
        }

        // const language = drupalSettings.path.currentLanguage;
        de_breadcrumb.append( `<li> <a href="/en/admin/mcdonalds">McDonald's</a></li>` );
    },

    start_spinning()
    {
        $('.c-save-delete').addClass( 'is-spinning' );
    },

    stop_spinning()
    {
        $('.c-save-delete').removeClass( 'is-spinning' );
    },

    async flash_background( de )
    {
        let red   =  255;
        let green =    0;
        let blue  =  255;
        while ( true ){

            await this.wait_for_animation_frame();

            // fac(255) → 3 5 17
            if ( red   + 10 < 255 ){ red   += 10; } else { red   = 255; }
            if ( green + 10 < 255 ){ green += 10; } else { green = 255; }
            if ( blue  + 10 < 255 ){ blue  += 10; } else { blue  = 255; }

            de.css( 'background-color', 'rgb( '+red+', '+green+', '+blue+')' );

            if ( red == 255 && green == 255 && blue == 255 ){
                break;
            }
        }
    },

    async wait_for_animation_frame()
    {
        return new Promise( ( resolve ) => {
            requestAnimationFrame( resolve );
        } )
    },
}

